import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate} from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';

function EditPersonalInfoSister() {

    const location = useLocation();
    const navigate = useNavigate();

    const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const editMemberId = location.state?.editMemberId;
    const memberId = location.state?.memberId;
    //console.log("Member ID is : ",memberId);

    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");

    const queryClient = useQueryClient();

      const [isSubmitting, setIsSubmitting] = useState(false);

    const [message, setMessage] = useState('');
    
    const [profile, setProfile] = useState({
        name: '',
        last_name: '',
        surname: '',
        n_prefix: '',
        date_of_birth: '',
        gender: '',
        status: '',
        profile_image: ''
        });

      const {
        data,
        isLoading,
        isError,
      } = useQuery({
        queryKey: ['userProfileDetails', editMemberId],
        queryFn: async () => {
          if (!editMemberId) throw new Error("No memberId provided");
      
          const res = await axios.get(`${API_URL}/edit-personalinfosister-settings-api?memberId=${editMemberId}`, {
            withCredentials: true,
          });
      
          return res.data;
        },
        enabled: !!editMemberId, // prevent fetch if memberId is undefined
        staleTime: 0,
        cacheTime: Infinity,
      });
      


     useEffect(() => {
        if (data) {
          if (data.Status === "Success") {
            const user = data.user;
      
            setProfile({
                name: user.name || '',
        last_name: user.last_name || '',
        surname: user.surname || '',
        n_prefix: user.n_prefix || '',
        date_of_birth: user.date_of_birth ? user.date_of_birth.substring(0, 10) : '',
        gender: user.gender || '',
        status: user.status || '',
        profile_image: user.profile_image || '',
            });
          } else {
            setMessage("Failed to load user data");
          }
        }
      }, [data]);


    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    
const [previewImage, setPreviewImage] = useState(null);

const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    try {
      const targetKB = 100;
      let quality = 0.9;
      let compressedFile = file;
  
      while (true) {
        const options = {
          maxSizeMB: targetKB / 1024,
          maxWidthOrHeight: 800, // Optional resize dimension
          initialQuality: quality,
          useWebWorker: true,
        };
  
        compressedFile = await imageCompression(file, options);
        
        // Break if under target size or quality is too low
        if (compressedFile.size / 1024 <= targetKB || quality <= 0.1) break;
        quality -= 0.1;
      }
  
      // Generate preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(compressedFile);
  
      // Update compressed image in state
      setProfile((prev) => ({
        ...prev,
        profile_image: compressedFile,
      }));
    } catch (err) {
      console.error('Image compression error:', err);
      toast.error('Failed to compress image.');
    }
  };



const handleProfileUpdate = async () => {
    const formData = new FormData();

    // If no new image is selected, pass the current image name to the backend
    if (profile.profile_image) {
        formData.append('image_name', profile.profile_image);
    }

    // Append the rest of the profile fields except the image
    Object.keys(profile).forEach((key) => {
        if (key !== 'profile_image') {
            formData.append(key, profile[key]);
        }
    });

    try {
        const response = await axios.put(
            `${API_URL}/edit-personalinfosister-settings-update-api?memberId=${editMemberId}`,  // ✅ add memberId to query
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            }
        );

        toast.success("Details updated successfully");
        navigate('/family-tree-sister', { state: { memberId } });

    } catch (error) {
        toast.error("Error updating profile");
        console.error('Error updating profile:', error);
    }
};

const handleCancel = () => {
  navigate('/family-tree-sister', { state: { memberId } });
};

    return (
         
        <div className="scrollPageContainer theme-light">
            <div className="main-wrapper">

            {/*start of header*/}
         {isSidebarVisible && <Sidebar />}
         <Header toggleSidebar={toggleSidebar} />
         {/*end of header */}
         {/*start of sidebar*/}
         <Sidebar show={showSidebar} toggle={toggleSidebar} />
         {/*End of sidebar*/}
         {/* start of footerbar */}
         <Footerbar toggleSidebar={toggleSidebar} />
         {/* end of footerbar */}
        <ToastContainer />

         <div className="page-wrapper">
         <div className="content container-fluid">

            <div className="row mt-3">

            <div className="col-md-12">

            <div className="card">
                <div className="card-body">


                <div className="row">
                        <div className="col-md-12">
                          
                            <center>
                            <div 
                                className="position-relative d-inline-block" 
                                style={{ cursor: 'pointer' }} 
                                onClick={() => document.getElementById('uploadImageInput').click()}
                            >
                                {profile.profile_image && (
                                <div className="mb-3">
                                    <img 
                                    src={previewImage || `${API_URL}/images/${profile.profile_image}`} 
                                    alt="Profile" 
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%', 
                                        border: '2px solid #ccc' 
                                    }}
                                    />
                                </div>
                                )}

                                {/* Edit Icon */}
                                <span 
                                className="avatar-camera-badge" 
                                style={{ position: 'absolute', bottom: '5px', right: '5px', 
                                     borderRadius: '50%', padding: '6px', 
                                     
                                }}
                                >
                               <i className="fas fa-camera" />
                                </span>

                                {/* Hidden Input */}
                                <input 
                                id="uploadImageInput" 
                                type="file" 
                                accept="image/*" 
                                onChange={handleImageChange} 
                                style={{ display: 'none' }}
                                />
                            </div>
                            </center>

                        </div>
                        </div>

                <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="form-label-modern small mb-1">First Name</label>
                    <input type="text" name="name" value={profile.name} onChange={handleChange} placeholder="First Name" className="form-input-modern form-control form-control-sm" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="form-label-modern small mb-1">Last Name</label>
                    <input type="text" name="last_name" value={profile.last_name} onChange={handleChange} placeholder="Last Name" className="form-input-modern form-control form-control-sm" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="form-label-modern small mb-1">Surname</label>
                    <input type="text" name="surname" value={profile.surname} onChange={handleChange} placeholder="Surname" className="form-input-modern form-control form-control-sm" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="form-label-modern small mb-1">Prefix</label>
                    <input type="text" name="n_prefix" value={profile.n_prefix} onChange={handleChange} placeholder="Name Prefix" className="form-input-modern form-control form-control-sm" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="form-label-modern small mb-1">Your Birthday</label>
                    <input type="date" name="date_of_birth" value={profile.date_of_birth} onChange={handleChange} className="form-input-modern form-control form-control-sm" />
                    </div>
                    <div className="col-6 col-md-6">
                    
                    </div>
                </div>
                
                <div className="mt-4 pt-3 border-top d-flex justify-content-between">
                                
                {( parseInt(loggedInUserId) === parseInt(memberId) ||
                      loggedFamilyAdmin === "1" ) && (
                <button
                  type="button"
                  className="btn-cta btn-save d-inline-flex align-items-center justify-content-center"
                  onClick={handleProfileUpdate}
                  disabled={isSubmitting || !profile.name.trim()}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Updating...
                    </>
                  ) : (
                    <>
                  
                      Update Member
                    </>
                  )}
                </button>
                )}

                <button
                  type="button"
                  className="btn-cta btn-cancel"
                  onClick={handleCancel}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>

  
</div>

               






                </div>
                </div>

                

        

                </div>

            </div>


            <div className='row end-page-space' >  </div>

            </div>
            </div>
        
        </div>



        <style jsx>{`
        :root{
          --brand: #75B437;
          --brand-600: #5fa12f;
          --brand-700: #4d8e29;
          --brand-dark: #184A2C;
          --ink: #0b1720;
          --bg: #EBF4ED;
          --bg-soft: #f4faf6;
        }
        .theme-light, .scrollPageContainer { background: var(--bg); }
        .text-brand { color: var(--brand-dark) !important; }
        .btn-brand{
          background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
          color:#fff; border:0;
          box-shadow: 0 4px 12px rgba(117,180,55,.35);
        }
        .btn-brand:hover{ filter: brightness(1.02); transform: translateY(-1px); }
        .btn-outline-brand{
          border: 2px solid var(--brand);
          color: var(--brand-dark);
          background: #fff;
        }
        .btn-outline-brand:hover{
          background: var(--brand);
          color:#fff;
        }
        .modern-breadcrumb a{ color: var(--brand-dark); }
        .modern-card{ background: linear-gradient(145deg, #ffffff 0%, var(--bg-soft) 100%); }

      
        .avatar-upload{ display:inline-flex; justify-content:center; align-items:center; }
        .avatar-circle{
          width:120px; height:120px; border-radius:50%;
          position:relative; overflow:hidden;
          border:4px solid #e2e8f0;
          box-shadow:0 8px 16px rgba(0,0,0,.08);
          transition: transform .15s ease, border-color .15s ease;
          background-size:cover; background-position:center; background-repeat:no-repeat;
          outline:none;
        }
        .avatar-circle:hover{ transform: translateY(-1px); border-color: var(--brand); cursor:pointer; }
        .avatar-circle.no-image{ background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%); }
        .avatar-placeholder{
          width:100%; height:100%; display:flex; align-items:center; justify-content:center;
          color:#fff; font-size:32px; opacity:.9;
        }
        .avatar-camera-badge{
          position:absolute; right:6px; bottom:6px; width:34px; height:34px;
          border-radius:50%; background: var(--brand); color:#fff;
          display:flex; align-items:center; justify-content:center;
          box-shadow:0 4px 10px rgba(24,74,44,.35); border:2px solid #fff;
        }
        .member-name{ color: var(--ink); }

     
        .form-label-modern{ font-size: .85rem; font-weight:600; color:#374151; }
        .form-input-modern{
          padding: .4rem .6rem !important;
          border:2px solid #e2e8f0 !important;
          border-radius:12px !important;
          font-size:.9rem !important;
          background:#fff !important;
        }
        .form-input-modern:focus{
          border-color: var(--brand) !important;
          box-shadow: 0 0 0 3px rgba(117,180,55,.2) !important;
        }
        .form-select.form-select-sm.form-input-modern{
          height: 36px !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }

        .page-title{ color: var(--ink); }




.btn-brand{
  background: linear-gradient(135deg, #75B437 0%, #184A2C 100%);
  color:#fff;
  border: none;
  border-radius: 14px;        
  font-weight: 700;
  box-shadow: 0 6px 16px rgba(24,74,44,.25);
}
.btn-brand:hover:not(:disabled){
  filter: brightness(1.03);
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(24,74,44,.35);
}


.btn-outline-brand{
  background: #F5F7FA;
  color: #64748B;
  border: 1px solid #E2E8F0;
  border-radius: 14px;
  font-weight: 700;
  box-shadow: 0 1px 0 rgba(0,0,0,.02), inset 0 0 0 1px rgba(255,255,255,.6);
}
.btn-outline-brand:hover{
  background: #EEF2F7;
  border-color: #D8E0E9;
}







.btn-save {
  background: linear-gradient(135deg, #75B437 0%, #184A2C 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(24,74,44,.25);
  transition: all 0.2s ease;
}
.btn-save:hover:not(:disabled) {
  filter: brightness(1.05);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(24,74,44,.35);
}

/* Cancel (soft grey, rounded like screenshot) */
.btn-cancel {
  background: #F5F7FA;
  color: #475569;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.btn-cancel:hover {
  background: #EEF2F7;
  border-color: #D1D9E6;
}

/* ===== Buttons bar (right on desktop, centered on mobile) ===== */
.actions-bar{
  display:flex;
  flex-direction:row;
  gap:12px;
  justify-content:flex-end;         /* like the screenshot */
}
@media (max-width: 768px){
  .actions-bar{ justify-content:center; }
}

/* ===== Shared button base (consistent size + rounded) ===== */
.btn-cta{
  --btn-h: 44px;                    /* visual height from screenshot */
  height: var(--btn-h);
  padding: 0 22px;                  /* tight horizontal padding */
  border-radius: 14px;              /* rounded corners */
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1;
  border: 0;
  transition: transform .15s ease, box-shadow .15s ease, filter .15s ease, background .15s ease;
  outline: none;
}
.btn-cta:active:not(:disabled){ transform: translateY(1px); }
.btn-cta:focus-visible{
  box-shadow: 0 0 0 3px rgba(117,180,55,.25);
}

/* ===== Save (green gradient) ===== */
.btn-save{
  background: linear-gradient(135deg, #75B437 0%, #184A2C 100%);
  color:#fff;
  box-shadow: 0 6px 16px rgba(24,74,44,.25);
}
.btn-save:hover:not(:disabled){
  filter: brightness(1.03);
  box-shadow: 0 10px 22px rgba(24,74,44,.35);
}

/* ===== Cancel (soft grey pill) ===== */
.btn-cancel{
  background:#F5F7FA;
  color:#475569;
  border:1px solid #E2E8F0;
  box-shadow: 0 1px 0 rgba(0,0,0,.02), inset 0 0 0 1px rgba(255,255,255,.6);
}
.btn-cancel:hover{
  background:#EEF2F7;
  border-color:#D8E0E9;
}

/* ===== Disabled state polish ===== */
.btn-cta:disabled{
  opacity:.85;
  cursor:not-allowed;
  box-shadow:none;
  transform:none;
}



      `}</style>
      
        </div>
    );
}

export default EditPersonalInfoSister;
